import {InsightsResponse} from '@findhotel/sapi/dist/types/packages/core/src/insights'
import {createApi} from '@reduxjs/toolkit/query/react'
import {getSeoApiUrl} from 'utils/apiUrls'

import {cacheFinalClientErrors} from '@vio/core/src/utils/network/cacheFinalClientErrors'
import {fetchBaseQuery} from '@vio/core/src/utils/network/fetchBaseQuery'

interface TranslateParams {
  hotelId: string
  lang: string
}

const API_URL = getSeoApiUrl()

export const translateInsightsApi = createApi({
  reducerPath: 'translateInsightsApi',
  // A hotel without review insights answers 404, which the AP preloads during
  // `getServerSideProps` and must not request again from the browser.
  baseQuery: cacheFinalClientErrors(fetchBaseQuery({baseUrl: API_URL})),
  endpoints: builder => ({
    translateInsights: builder.query<InsightsResponse, TranslateParams>({
      query: ({hotelId, lang}) => ({
        url: '/translate-insights',
        method: 'GET',
        params: {hotelId, lang}
      })
    })
  })
})

export const {useTranslateInsightsQuery} = translateInsightsApi
